// export const domain = "http://127.0.0.1:8000/api";
// export const domain = "https://somboonapi.kisrateam.com/api";
//dev server
// export const domain = "https://somboonapi.kisrasprint.com/api";
// export const domain = "https://somboonprodapi.kisrasprint.com/api";
// export const domain = "https://somboonapi.ksta.co/api";
// export const domain = "https://sbpack.co/somboon/api";
//prod server
export const domain = "https://sbpack.co:3000/api";
